import { isEmpty } from 'lodash';

import { TurnoversFilters } from '@shared/interfaces/turnovers-filters.interface';

export const checkKanbanFilterEmpty = (turnoversFilters: TurnoversFilters): boolean =>
  isEmpty(turnoversFilters) ||
  (!turnoversFilters.assignee &&
    !turnoversFilters.unitName &&
    !turnoversFilters.workflowPhaseType?.length &&
    !turnoversFilters.finish?.length &&
    !turnoversFilters.moveOutType?.length &&
    !turnoversFilters.unitType?.length &&
    !turnoversFilters.label?.length);
